import React, {forwardRef} from "react";
import CrewCard from "../../../crews/components/cards/CrewCard";

const ExportPreview = forwardRef(({teams, teamCount}, ref) => {

    /**
     * DATA TRANSFORMER:
     * Transforms the internal TeamBuilder state (Slot Key)
     * into the structure expected by `CrewCard` (Position Array)
     * 
     * Input: { 'Captain' : {id:1...}, 'Crewmate1': {id:2...} }
     * Output: [ {position: 'Captain', character_id: 1...}, ...] 
     */
    const transformDataForCard = (teamDataMap, title) => {
        const members = [];
        Object.keys(teamDataMap).forEach(key => {
            if(teamDataMap[key]){
                const finalNotes = teamDataMap[key].notes || null;

                members.push({
                    position: key,
                    character_id: teamDataMap[key].id,
                    ...teamDataMap[key],
                    notes: finalNotes
                });
            }
        });
        return{
            id: 'export-preview',
            title: title,
            members: members
        };
    };

    return(
        <div 
            ref={ref}
            className="export-container"
            style={{
                position: 'fixed',
                top: '0',
                left: '0',
                zIndex: '-1000',
                opacity: '0',
                pointerEvents: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: teamCount === 1 ? '550px' : '950px',
                padding: '40px',
                background: 'linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-card) 100%)',
                gap: '20px'
            }}
        >
            <div style={
                {width: '100%', 
                textAlign: 'center', 
                marginBottom: '10px', 
                color: 'var(--text-muted)', 
                fontSize: '1.5rem', 
                fontWeight: 'bold', 
                textTransform: 'uppercase', 
                letterSpacing: '4px',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>Team Builder</div>

            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '30px',
                width: '100%'
            }}>

                {teams.map((team, idx) => (
                    <div key={idx} style={{display: 'flex', transformOrigin: 'center'}}>
                        <CrewCard 
                            crew={transformDataForCard(team.data, team.title)}
                            exportMode={true}
                        />
                    </div>
                ))}
            </div>

            <div style={{
                width: '100%', 
                textAlign: 'right', 
                marginTop: '10px', 
                color: 'var(--text-500)', 
                fontStyle:'italic',
                fontSize: '0.9rem',
                opacity: 0.8
            }}>Generated by OPTC-Crews</div>
        </div>
    );


});

export default ExportPreview;